import EventBus from '@/scripts/event-bus';

export const APPOINTMENT_REQUEST_DETAILS_WIDGET_NAME = 'appointment-request-details-widget';

export function openAppointmentRequestDetailsWidget(config) {
  return EventBus.$emit('open-widget', {
      name: APPOINTMENT_REQUEST_DETAILS_WIDGET_NAME,
      config: {
        id: config.id
      },
  });
}
